<template>
  <div
    class="main-block-container"
    :style="{
      marginTop: headerHeight + 'px',
      height: `calc(100vh - ${headerHeight}px)`,
    }"
  >
      <div class="page-header-container" v-gsap-fade-up="{ offset: 40, duration: 1.1 }">
      <div class="page-header">
        <div class="icon">
          <svg
            width="155"
            height="155"
            viewBox="0 0 128 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="128" height="128" fill="white" />
            <path
              d="M47.3909 90.2551C46.9148 85.6365 48.216 81.4935 50.2174 77.5245C52.7749 72.4527 56.1854 67.9688 59.7494 63.5872C62.2265 60.5419 64.7668 57.5376 66.7617 54.1281C67.0034 53.7151 67.233 53.2879 67.4063 52.8428C68.3596 50.3954 67.327 48.668 64.7226 48.2515C62.0102 47.8176 59.4324 48.4035 56.9158 49.3047C50.4266 51.6285 45.4283 55.8647 41.7538 61.6684C39.4682 65.2784 38.3549 69.2973 37.9769 73.569C37.5533 78.3561 38.3662 82.8962 40.2124 87.2879C40.5949 88.1977 40.8424 89.1274 40.2444 90.0437C39.2962 91.4964 37.4497 91.6612 36.1592 90.3386C34.7764 88.9212 33.6023 87.3241 32.4818 85.6867C29.3298 81.0808 27.3287 76.0009 26.5005 70.4901C25.5268 64.0112 25.9127 57.6347 28.1983 51.4194C30.1165 46.2033 32.8516 41.5503 36.9609 37.7778C37.2538 37.5089 37.5146 37.152 38.0288 37.1407C38.1303 37.6152 37.8457 37.9133 37.6499 38.2227C35.7693 41.1946 33.9822 44.2161 32.8847 47.5886C32.5414 48.6435 32.2333 49.7153 31.9953 50.7986C31.4718 53.1818 33.1379 54.7184 35.4428 53.9663C37.248 53.3772 38.6666 52.1577 40.011 50.8664C44.3928 46.6574 49.0413 42.812 54.434 39.9575C58.2134 37.957 62.1731 36.4719 66.416 35.9016C69.2653 35.5186 72.1309 35.4557 74.928 36.356C76.5508 36.8782 78.0118 37.6948 79.1286 38.9998C81.0736 41.2725 81.1156 43.8842 80.1674 46.546C78.8181 50.334 76.1259 53.182 73.3532 55.9323C69.8218 59.4351 66.1183 62.7594 62.6662 66.3457C59.2019 69.9448 56.0119 73.7561 53.7701 78.2705C52.4723 80.8841 51.617 83.6159 52.145 86.6054C52.792 90.268 55.1769 92.2578 58.5804 93.0333C62.9736 94.0343 67.271 93.2341 71.4001 91.6828C80.7595 88.1666 87.8875 82.0044 92.5224 73.0488C94.3877 69.4446 95.4766 65.602 95.6637 61.5044C95.9946 54.2566 93.6013 47.9302 89.266 42.292C85.3807 37.2391 80.3675 33.7047 74.3603 31.6333C71.109 30.5122 67.752 30.0967 64.3148 30.164C59.0315 30.2674 54.2615 31.989 49.7638 34.6481C48.8892 35.1652 47.9968 35.6548 47.092 36.1162C46.4375 36.4499 45.7351 36.552 45.0023 36.3627C43.8692 36.0701 43.2479 34.9867 43.6054 33.8626C43.8908 32.9654 44.4956 32.3101 45.2504 31.7859C49.1268 29.0937 53.4497 27.5275 58.0451 26.6497C59.9516 26.2855 61.8764 26.0233 63.8134 26.0029C68.7414 25.9508 73.5686 26.606 78.1797 28.4407C87.6358 32.2031 94.7046 38.6174 99.2049 47.826C101.418 52.3545 102.58 57.1684 102.917 62.2006C103.239 67.0022 102.617 71.6829 101.13 76.2339C99.5827 80.9666 97.1617 85.2286 93.9545 89.0311C89.041 94.8568 83.0028 99.0437 75.7676 101.348C71.2423 102.79 66.5806 103.33 61.8118 102.801C58.4301 102.426 55.2576 101.578 52.4925 99.4924C49.4483 97.1962 47.8383 94.0965 47.3909 90.2551Z"
              fill="black"
            />
          </svg>
        </div>
        <h1 v-gsap-heading="{ delay: 0.1 }">ZERO</h1>
      </div>
      <div class="page-header">
        <div class="icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="155"
            height="155"
            viewBox="0 0 155 155"
            fill="none"
          >
            <rect width="155" height="155" rx="20.5634" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M85.3657 47.7638C84.499 48.5884 63.8611 104.089 63.8717 105.567C63.8913 108.289 68.1106 108.946 69.2812 106.41C70.3363 104.125 90.1024 50.3964 90.1024 49.8139C90.1024 47.3646 87.1353 46.0804 85.3657 47.7638ZM50.7647 56.4866C49.5663 57.0329 30.3078 76.6261 30.0908 77.5195C29.7128 79.0765 30.1012 79.5515 39.5899 89.1363C50.0421 99.6947 50.4588 99.9839 52.5131 98.1108C54.5467 96.2569 54.0855 95.5176 45.1356 86.2886C40.8739 81.894 37.3872 78.1977 37.3872 78.0744C37.3872 77.9511 41.2614 73.9483 45.9968 69.1797C55.3541 59.756 55.4034 59.6901 54.5056 57.7935C53.8285 56.3633 52.2471 55.8107 50.7647 56.4866ZM100.534 56.88C100.08 57.1591 99.5774 57.7649 99.4176 58.2263C98.7816 60.0648 98.9029 60.223 108.019 69.4559C112.735 74.2309 116.592 78.2532 116.592 78.3943C116.592 78.5352 112.986 82.2847 108.579 86.7265L100.566 94.8024V95.9737C100.566 97.8063 102.229 99.2106 103.997 98.87C104.75 98.7251 123.132 81.0078 123.764 79.8175C124.098 79.1904 124.073 77.8118 123.717 77.1016C123.3 76.2722 104.422 57.2149 103.559 56.7532C102.582 56.2299 101.52 56.2745 100.534 56.88Z"
              fill="black"
            />
          </svg>
        </div>
        <h1 v-gsap-heading="{ delay: 0.25 }">LIQUID</h1>
      </div>
      <div class="underheader-container" v-gsap-fade-up="{ offset: 20, delay: 0.4 }">
        <img :src="butterflyGif" alt="Butterfly" class="butterfly-sticker" />
        <h5 class="underheader">{{ $t("main.underheader") }}</h5>
      </div>
    </div>
    <div class="spline-wrapper">
      <spline-viewer
        url="https://prod.spline.design/DQmUdHBmdI9n-NUY/scene.splinecode"
        class="spline-viewer"
      ></spline-viewer>
      <div class="spline-logo-cover"></div>
    </div>
  </div>
</template>

<script>
import "@splinetool/viewer";
import butterflyGif from "@/assets/butterfly.gif";

export default {
  name: "MainBlock",
  props: {
    headerHeight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      butterflyGif: butterflyGif,
    };
  },
  mounted() {
    this.hideSplineLogo();
    // Также слушаем изменения, так как Spline может загружаться асинхронно
    this.$nextTick(() => {
      setTimeout(() => this.hideSplineLogo(), 500);
      setTimeout(() => this.hideSplineLogo(), 1000);
      setTimeout(() => this.hideSplineLogo(), 2000);
    });
  },
  methods: {
    hideSplineLogo() {
      const splineViewer = this.$el?.querySelector('.spline-viewer');
      if (!splineViewer) return;

      const shadowRoot = splineViewer.shadowRoot;
      if (!shadowRoot) return;

      const logoElement = shadowRoot.querySelector('#logo');
      if (logoElement) {
        logoElement.style.setProperty('display', 'none', 'important');
      }
    },
  },
};
</script>

<style scoped>
.main-block-container {
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  max-height: 100vh;
  position: relative;
  padding-top: 32px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(32px, 4vw, 64px);
}

.spline-wrapper {
  flex: 0 0 auto;
  width: 40%;
  aspect-ratio: 1 / 1;
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: clamp(16px, 1.67vw, 32px);
}

.spline-viewer {
  width: 100%;
  height: 100%;
  display: block;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.spline-logo-cover {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 200px;
  height: 70px;
  background-color: #000000;
  z-index: 10;
  pointer-events: none;
}

.icon svg {
  border-radius: clamp(16px, 1.67vw, 32px);
  width: clamp(77px, 8.07vw, 155px);
  height: clamp(77px, 8.07vw, 155px);
}

.page-header-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: clamp(16px, 2vw, 32px);
  box-sizing: border-box;
}

.underheader-container {
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
}

.page-header {
  display: flex;
  justify-content: start;
  box-sizing: border-box;
  align-items: center;
  gap: 32px;
}

.page-header h1 {
  font-size: clamp(88px, 11.56vw, 222px);
  font-weight: 300;
  line-height: 0px;
  text-transform: uppercase;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.underheader {
  text-transform: uppercase;
  letter-spacing: clamp(2px, 0.31vw, 6px);
  font-weight: 100;
  margin: 0;
  font-size: clamp(10px, 0.83vw, 16px);
}

.butterfly-sticker {
  width: clamp(24px, 2.5vw, 48px);
  height: auto;
  transform: rotate(-15deg);
  filter: drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.3));
  transition: transform 0.3s ease;
  animation: float 3s ease-in-out infinite;
}

.butterfly-sticker:hover {
  transform: rotate(-10deg) scale(1.1);
}

@keyframes float {
  0%,
  100% {
    transform: rotate(-15deg) translateY(0px);
  }
  50% {
    transform: rotate(-15deg) translateY(-10px);
  }
}

@media screen and (max-width: 1024px) {
  .main-block-container {
    flex-direction: column;
    padding-left: 5%;
    padding-right: 5%;
    align-items: center;
  }

  .spline-wrapper {
    width: 100%;
    order: 1;
  }

  .page-header-container {
    order: 2;
    justify-content: center;
    align-items: start;
    text-align: center;
  }
}

@media screen and (max-width: 768px) {
  .main-block-container {
    padding-left: 5%;
    padding-right: 5%;
  }

  .spline-wrapper {
    width: 100%;
    pointer-events: none;
  }

  .page-header {
    flex-wrap: wrap;
    justify-content: center;
    gap: clamp(16px, 2vw, 32px);
  }

  .page-header h1 {
    font-size: clamp(40px, 8vw, 88px);
  }
}
</style>
